(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  // Once someone moves the announcements with the arrows, stop the rotation and let screen
  // readers announce the slide they picked. Capture phase, so the region is live before the
  // slide changes.
  document.addEventListener(
    'click',
    (event) => {
      if (!(event.target instanceof Element)) return;

      const bar = event.target.closest('.slideshow-control')?.closest('announcement-bar-component');
      if (!bar || !bar.hasAttribute('autoplay')) return;

      bar.setAttribute('aria-live', 'polite');
      if (typeof bar.pause === 'function') bar.pause();
    },
    true
  );

  } catch(e) { console.error(e); }
})();
})();
